const SET_RATES = (state, data) => {
  state.id = data.id
  state.hasResult = data.hasResult
  state.hasCountryDeal = data.hasCountryDeal
  state.hasGlobalUnlimited = data.hasGlobalUnlimited
  state.hasUnlimited = data.hasUnlimited
  state.hasMembership = data.hasMembership
  state.countryName = data.countryName
  state.toCountry = data.toCountry
  state.hasAppToApp = data.rebelCalling.hasResult
  state.unlimited = data.unlimited
  state.globalUnlimited = data.globalUnlimited
  state.worldCredit = data.worldCredit
  state.limited = data.deal
  state.recargas = data.recargas
  state.membership = data.membership
}
export default {
  SET_RATES
}



// WEBPACK FOOTER //
// ./src/store/modules/rates/mutations.js